import { createRouter, createWebHashHistory } from 'vue-router'

const navLinks = [
    // internal routes
    // list of pages getting data from json
    { id: '1', type: 'internal', route: '/home' },


    { id: '2', type: 'internal', route: '/business' },
    { id: '2', type: 'internal', route: '/language' },
    { id: '2', type: 'internal', route: '/news' },
    { id: '2', type: 'internal', route: '/university' },

    { id: '3', type: 'internal', route: '/business/introduction' },
    { id: '6', type: 'internal', route: '/business/ireland' },

    { id: '5', type: 'internal', route: '/language/school1' },
    { id: '5', type: 'internal', route: '/language/school2' },
    { id: '5', type: 'internal', route: '/language/school3' },
    { id: '4', type: 'internal', route: '/university/university1' },
    { id: '4', type: 'internal', route: '/university/university2' },
    { id: '4', type: 'internal', route: '/university/university3' },
    { id: '4', type: 'internal', route: '/university/university4' },
    { id: '4', type: 'internal', route: '/university/university5' },
    { id: '4', type: 'internal', route: '/university/university6' },

    // external sites - I haven't really used internal or external feature
    // It is only useful when there's dropdown menu
    { id: 'C', label: 'External C', type: 'external', url: 'https://external.site/C' },
    { id: 'F', label: 'External F', type: 'external', url: 'https://another.site/F' },
];

const internalRoutes = navLinks
    .filter(link => link.type === 'internal')
    .map(link => {
        const path = link.route;
        return {
            path,
            name: path, // name must be unique
            component: () => import(`@/views/page-${link.id}.vue`),
        };
    });


const routes = [
    { path: '/', redirect: '/home' },
    {
        path: '/consult',
        name: 'consult',
        beforeEnter() {
            window.open(
                'https://docs.google.com/forms/d/16TVwEO9gBQehcD3QEcU1teVAYnx8_ieTPGos00ZNPIc/edit',
                '_blank'
            );
            return false; // cancel the internal navigation
        }
    },
    ...internalRoutes,
];



const router = createRouter({
    history: createWebHashHistory(), // hash mode
    routes
})
console.log('Registered routes:', router.getRoutes().map(r => r.path));

export default router
